import React from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { theme, media } from '../../styles/theme';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${theme.colors.background};
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 260px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  @media (max-width: ${theme.breakpoints.lg}) {
    margin-left: 0;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  padding: ${theme.spacing.xl};
  padding-top: ${theme.spacing.lg};
  padding-bottom: 100px;
  overflow-y: auto;

  @media (max-width: ${theme.breakpoints.lg}) {
    padding: ${theme.spacing.md};
    padding-top: ${theme.spacing.md};
    padding-bottom: 80px;
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    padding: ${theme.spacing.sm};
    padding-top: ${theme.spacing.sm};
    padding-bottom: 80px;
  }
`;

const PageHeader = styled.div`
  margin-bottom: ${theme.spacing['2xl']};
  
  h1 {
    font-size: ${theme.typography.fontSize['4xl']};
    font-weight: ${theme.typography.fontWeight.bold};
    color: ${theme.colors.text};
    margin-bottom: ${theme.spacing.sm};
    background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.accentTeal} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    color: ${theme.colors.textSecondary};
    font-size: ${theme.typography.fontSize.lg};
    margin: 0;
  }

  ${media.down.sm} {
    margin-bottom: ${theme.spacing.xl};
    
    h1 {
      font-size: ${theme.typography.fontSize['2xl']};
    }
    
    p {
      font-size: ${theme.typography.fontSize.base};
    }
  }
`;

function PageLayout({ children, title, description, user, showHeader = true }) {
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent>
        {showHeader && <Header user={user || { name: 'Admin User', role: 'Administrator' }} />}
        <ContentWrapper>
          {(title || description) && (
            <PageHeader>
              {title && <h1>{title}</h1>}
              {description && <p>{description}</p>}
            </PageHeader>
          )}
          {children}
        </ContentWrapper>
        <Footer />
      </MainContent>
    </LayoutContainer>
  );
}

export default PageLayout;
